
// import { HTMLComponentJSON } from './HTML-Component-JSON';
import { HTMLGenricComponent } from "./HTML-Genric-Component.JSON";

export class HTMLDisplayComponentRequestJSON {
    displayLable: String;
    componentTypeID: Number;
    selectedDropDown:Number;
    selectedRadio:Number;
    selectedCheckBox:Number[];
    inputHTMLComponentJSONList: HTMLGenricComponent[];

    constructor(){
      this.displayLable = new String;
      this.inputHTMLComponentJSONList = new Array<HTMLGenricComponent>();
    }
}